module.exports = __webpack_public_path__ + "static/img/mazzo-di-carte-7.300b101.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mazzo-di-carte-7.svg
// module id = gzyr
// module chunks = 1